const size = 1024

function sizeChange(mq) {
  if (mq.matches) {
    if (document.body.classList.contains('mobile')) {
      document.body.classList.remove('mobile')
    }
    if (!document.body.classList.contains('desktop')) {
      document.body.classList.add('desktop')
    }
  } else {
    if (!document.body.classList.contains('mobile')) {
      document.body.classList.add('mobile')
    }
    if (document.body.classList.contains('desktop')) {
      document.body.classList.remove('desktop')
    }
  }
}

const mq = matchMedia(`(min-width: ${size}px)`)
mq.addEventListener('change', sizeChange)
sizeChange(mq)
